import {useQuery} from '@tanstack/react-query';
import {useChekinSDK} from 'context/ChekinSDK';
import {QUERY_CACHE_KEYS} from 'utils/constants';

type Props = {
  enabled?: boolean;
  reservationId?: string;
};
function useFetchReservationPayments({reservationId}: Props = {}) {
  const {getReservationPayments} = useChekinSDK();
  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.reservationPayments, reservationId],
    queryFn: () => getReservationPayments(reservationId ?? ''),
    enabled: Boolean(reservationId),
  });
}

export {useFetchReservationPayments};
